import { useEffect, useState } from "react"
import { useWindowSize } from "usehooks-ts"

import FullScreenImage, { type FullScreenImageProps } from "~/components/ui/FullScreenImage"
import type { ImageProps } from "~/components/ui/Image"
import ImageGallery from "~/components/ui/ImageGallery"

import { breakpoints } from "~/styles/variables/breakpoints"

export interface ProductImagesZoomProps {
  className?: string
  images?: ImageProps[]
  isZoomed?: boolean
  closeZoom?(): void
  openZoom?(): void
  imageIndex: number
  setImageIndex?(number: number): void
  onPreviousClick?: FullScreenImageProps["onPreviousClick"]
  onNextClick?: FullScreenImageProps["onNextClick"]
}

export function useProductImagesZoom(): ProductImagesZoomProps {
  const [imageIndex, setImageIndex] = useState(0)
  const [isZoomed, setIsZoomed] = useState(false)
  return {
    isZoomed,
    closeZoom: () => setIsZoomed(false),
    openZoom: () => setIsZoomed(true),
    imageIndex,
    setImageIndex,
  }
}
function ProductImagesZoom({
  images,
  isZoomed,
  closeZoom,
  imageIndex,
  onPreviousClick,
  onNextClick,
}: ProductImagesZoomProps) {
  const windowRect = useWindowSize()
  const isMobile = windowRect.width < breakpoints.lg

  useEffect(() => {
    if (!isZoomed) {
      closeZoom?.()
    }
  }, [isZoomed, closeZoom])
  if (!images) return null
  return isZoomed ? (
    <>
      {!isMobile ? (
        <FullScreenImage
          key={`fullScreenImage${images?.[imageIndex]?.src}`}
          onExitFullscreen={closeZoom}
          onPreviousClick={onPreviousClick}
          onNextClick={onNextClick}
          imageProps={images?.[imageIndex]}
        />
      ) : (
        <ImageGallery
          setImageIndex={() => {}}
          imageIndex={imageIndex}
          onExitFullscreen={closeZoom}
          imagesProps={images}
        />
      )}
    </>
  ) : null
}

export default ProductImagesZoom
